import { useState, useEffect } from 'react';
import axios from 'axios';

const AddItem = () => {
  const [items, setItems] = useState([]);
  const [itemName, setItemName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [typeOfSock, setType] = useState('');
  const [quantity, setQuantity] = useState('');

  // Password section
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Track authentication
  const [password, setPassword] = useState(''); // Track password input

  // State for editing an item
  const [editingItem, setEditingItem] = useState(null);
  const [editName, setEditName] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [editPrice, setEditPrice] = useState('');
  const [editType, setEditType] = useState('');
  const [editQuantity, setEditQuantity] = useState('');

  // Fetch all items from the database
  useEffect(() => {
    if (isAuthenticated) {
      fetchItems();
    }
  }, [isAuthenticated]);

  const fetchItems = async () => {
    try {
      const response = await axios.get('https://cottonlocalhost1365.onrender.com/api/items');
      setItems(response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://cottonlocalhost1365.onrender.com/api/items/auth', { password });

      if (response.data.success) {
        setIsAuthenticated(true); // User authenticated
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Error during authentication', error);
    }
  };

  const addItem = () => {
    axios
      .post('https://cottonlocalhost1365.onrender.com/api/items', {
        name: itemName,
        description: description,
        price: price,
        typeOfSock: typeOfSock,
        quantity: quantity,
      })
      .then((response) => {
        setItems([...items, response.data]); // Add new item to the state
        setItemName('');
        setDescription('');
        setPrice('');
        setType('');
        setQuantity('');
      })
      .catch((error) => {
        console.error('There was an error adding the item!', error);
      });
  };

  const deleteItem = async (id) => {
    console.log('Deleting item with ID:', id); // Debugging
    try {
      const response = await axios.delete(
        `https://cottonlocalhost1365.onrender.com/api/items/delete/${id}` // Use the new delete route
      );
      console.log('Delete response:', response.data); // Debugging
      fetchItems(); // Refresh the list after deletion
    } catch (error) {
      console.error('Error deleting item:', error);
      if (error.response) {
        console.error('Response data:', error.response.data); // Debugging
        console.error('Response status:', error.response.status); // Debugging
      }
    }
  };

  const startEditing = (item) => {
    setEditingItem(item._id);
    setEditName(item.name);
    setEditDescription(item.description);
    setEditPrice(item.price);
    setEditType(item.typeOfSock);
    setEditQuantity(item.quantity);
  };

  const cancelEditing = () => {
    setEditingItem(null);
  };

  const updateItem = async (id) => {
    console.log('Updating item with ID:', id); // Debugging
    try {
      const response = await axios.put(
        `https://cottonlocalhost1365.onrender.com/api/items/update/${id}`, // Use the new update route
        {
          name: editName,
          description: editDescription,
          price: editPrice,
          typeOfSock: editType,
          quantity: editQuantity,
        }
      );
      console.log('Update response:', response.data); // Debugging
      fetchItems(); // Refresh the list after update
      setEditingItem(null); // Exit editing mode
    } catch (error) {
      console.error('Error updating item:', error);
      if (error.response) {
        console.error('Response data:', error.response.data); // Debugging
        console.error('Response status:', error.response.status); // Debugging
      }
    }
  };

  return (
    <div className="mt-28 md:mt-0 flex flex-col items-center text-black m-5 h-screen">
      {!isAuthenticated ? (
        <form onSubmit={handleLoginSubmit} className="flex items-center">
          <h2 className="m-5">Enter Password</h2>
          <input
            type="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Password"
            className="text-black"
          />
          <button type="submit" className="m-5 bg-indigo-600 rounded-2xl w-20">
            Enter
          </button>
        </form>
      ) : (
        <div className="z-50 w-full max-w-7xl">
          {/* Add Item Section */}
          <div className="flex lg:flex-row flex-col m-6 items-center min-h-[300px] rounded-xl">
            <div className="flex flex-col">
              <label>Img Link</label>
              <input
                type="text"
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
                placeholder="Img Link here.."
                className="m-3 text-black rounded-xl text-center"
              />
            </div>
            <div className="flex flex-col">
              <label>Description</label>
              <input
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="New description here.."
                className="m-3 text-black rounded-xl text-center"
              />
            </div>
            <div className="flex flex-col">
              <label>Price</label>
              <input
                type="text"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="New Price here.."
                className="m-3 text-black rounded-xl text-center"
              />
            </div>
            <div className="flex flex-col">
              <label>Type</label>
              <input
                type="text"
                value={typeOfSock}
                onChange={(e) => setType(e.target.value)}
                placeholder="Type of sock here.."
                className="m-3 text-black rounded-xl text-center"
              />
            </div>
            <div className="flex flex-col">
              <label>Quantity</label>
              <input
                type="text"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                placeholder="Quantity of sock here.."
                className="m-3 text-black rounded-xl text-center"
              />
            </div>
            <button
              onClick={addItem}
              className="my-5 hover:-translate-y-1 duration-300 hover:bg-indigo-400 rounded-xl w-[100px] h-10"
            >
              Add Item
            </button>
          </div>

          {/* Stock Management Section */}
          <div className="mt-10">
            <h2 className="text-2xl font-bold mb-4">Stock Management</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {items.map((item) => (
                <div key={item._id} className="bg-white p-4 rounded-lg shadow-lg">
                  <img src={item.name} alt={item.description} className="w-full h-32 object-cover rounded-lg mb-2" />
                  {editingItem === item._id ? (
                    <div className="space-y-2">
                      <input
                        type="text"
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                        className="w-full p-2 border rounded"
                      />
                      <input
                        type="text"
                        value={editDescription}
                        onChange={(e) => setEditDescription(e.target.value)}
                        className="w-full p-2 border rounded"
                      />
                      <input
                        type="text"
                        value={editPrice}
                        onChange={(e) => setEditPrice(e.target.value)}
                        className="w-full p-2 border rounded"
                      />
                      <input
                        type="text"
                        value={editType}
                        onChange={(e) => setEditType(e.target.value)}
                        className="w-full p-2 border rounded"
                      />
                      <input
                        type="text"
                        value={editQuantity}
                        onChange={(e) => setEditQuantity(e.target.value)}
                        className="w-full p-2 border rounded"
                      />
                      <div className="flex space-x-2">
                        <button
                          onClick={() => updateItem(item._id)}
                          className="bg-green-500 text-white px-4 py-2 rounded"
                        >
                          Save
                        </button>
                        <button
                          onClick={cancelEditing}
                          className="bg-gray-500 text-white px-4 py-2 rounded"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      <p className="text-lg font-semibold">{item.description}</p>
                      <p className="text-gray-600">Price: {item.price} €</p>
                      <p className="text-gray-600">Type: {item.typeOfSock}</p>
                      <p className="text-gray-600">Quantity: {item.quantity}</p>
                      <div className="flex space-x-2">
                        <button
                          onClick={() => startEditing(item)}
                          className="bg-blue-500 text-white px-4 py-2 rounded"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => deleteItem(item._id)}
                          className="bg-red-500 text-white px-4 py-2 rounded"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddItem;